export const OAUTH: OrgInfo['ssoProtocol'] = 'OAUTH';
export const SAML: OrgInfo['ssoProtocol'] = 'SAML';
export const NEW_WINDOW_PARAMS =
  'height=700,width=700,status=yes,toolbar=no,menubar=no,location=no';
export const SSO_PATH_ERROR = 'No ssoPath is provided in the orgInfo';
export const POPUP_ERROR = 'Popup blocked! Please allow popups for this site.';
export const SSO_PROTOCOL_ERROR = 'Wrong ssoProtocol is provided in the orgInfo';
export const SSO_ERROR_TOAST_TEXT = 'SSO authentication error';
export const LA_LOGIN_ERROR = "We couldn't log you in. Please try again";
export const ACCOUNT_CODE_MISMATCH_ERROR =
  'Account code mismatch. Please log in with the correct account.';
export const POPUP_CLOSE_CHECK_INTERVAL_MS = 500;
export const POPUP_RESULT_POLLING_INTERVAL_MS = 500;
export const POPUP_RESULT_POLLING_TIMEOUT_MS = 5000;
